class CustomSubscription extends HTMLElement{
    constructor() {
        super();
        this.sellingPlanIdSelect = document.querySelector('.subscribe-type');
        this.sellingPlanPurchases = document.querySelectorAll("[name='purchase']");
        this.init();
    }

    init() {
        this.sellingPlanPurchases.forEach(radio => {
            radio.addEventListener('change', (event) => {
                if (event.target.value == "subscribe") {
                    this.sellingPlanIdSelect.disabled = false;
                }else{
                    this.sellingPlanIdSelect.disabled = true;
                }
            });
        });

        this.applyUrlParams();
        this.initOneTimeAddToCart();
    }

    // Experiment "De-emphasize one-time purchase": the one-time option is rendered as a
    // link that adds to the cart in a single press, instead of a radio the customer picks
    // before pressing Add to Cart. The button is absent when the experiment is off, so
    // this quietly does nothing in the default layout.
    initOneTimeAddToCart() {
        const button = this.querySelector('[data-onetime-add-to-cart]');

        button?.addEventListener('click', () => this.addOneTimeToCart());
    }

    /**
     * Adds the product to the cart as a one-time purchase.
     *
     * We reuse the page's normal product form, so the variant, the 1-bag / 2-bag quantity,
     * the loading state, the cart drawer and the analytics events all behave exactly as
     * they do for the Add to Cart button. The only thing we change is the subscription:
     * unchecking its radio means the form posts no `selling_plan`, and a line with no
     * selling plan is how Shopify recognises a one-time purchase.
     *
     * `requestSubmit()` runs the form's submit handler synchronously, so the form fields
     * have already been read by the time it returns. Re-checking the radio right after is
     * therefore safe, and it leaves the main Add to Cart button selling the subscription.
     */
    addOneTimeToCart() {
        const subscriptionRadio = this.querySelector('input[name="selling_plan"]');
        // `.form` resolves the radio's form="" attribute, so this finds the product form
        // even though the radio lives outside the <form> element it belongs to.
        const form = subscriptionRadio?.form;

        if (!form) return;

        subscriptionRadio.checked = false;

        try {
            form.requestSubmit();
        } catch (error) {
            // Nothing reached the cart. We log rather than rethrow because there is no
            // recovery to offer the customer, and `finally` has already put the page
            // back into a consistent state.
            console.warn('One-time add to cart failed; nothing was added to the cart.', error);
        } finally {
            // Runs whether or not the submit threw, so the main Add to Cart button is
            // never left silently selling one-time purchases.
            subscriptionRadio.checked = true;
        }
    }

    // Pre-selects quantity and selling_plan radios from URL params.
    // Supports deep links from Klaviyo, e.g. ?quantity=2&selling_plan=<id>
    // - Missing params => leave defaults untouched.
    // - Empty selling_plan ("?selling_plan=") => one-time purchase radio.
    // - Invalid values => silent fallback (no matching radio, no-op).
    applyUrlParams() {
        const params = new URLSearchParams(window.location.search);
        const qty = params.get('quantity');
        const planId = params.get('selling_plan');

        if (qty !== null) {
            const qtyRadio = this.querySelector(`input[name="quantity"][value="${CSS.escape(qty)}"]`);
            qtyRadio?.click();
        }

        if (planId !== null) {
            const planRadio = this.querySelector(`input[name="selling_plan"][value="${CSS.escape(planId)}"]`);
            planRadio?.click();
        }
    }
}

if (!customElements.get('custom-subscription')) {
  customElements.define('custom-subscription', CustomSubscription);
}